<template>
    <div class="component-demo">
        <h1>基础组件演示</h1>

        <section class="demo-section">
            <h2>按钮组件</h2>
            <div class="demo-row">
                <ola-button>默认按钮</ola-button>
                <ola-button type="primary">主要按钮</ola-button>
                <ola-button type="success">成功按钮</ola-button>
                <ola-button type="danger">危险按钮</ola-button>
                <ola-button type="secondary">次要按钮</ola-button>
                <ola-button size="sm">小按钮</ola-button>
            </div>

            <div class="demo-row">
                <ola-button round>圆角按钮</ola-button>
                <ola-button outline round>线框按钮</ola-button>
                <ola-button disabled>禁用按钮</ola-button>
                <ola-button size="sm">小按钮</ola-button>
                <ola-button size="lg">大按钮</ola-button>
            </div>
        </section>

        <section class="demo-section">
            <h2>菜单组件</h2>
            <ola-menu mode="horizontal" default-active="1">
                <ola-menu-item index="1">首页</ola-menu-item>
                <ola-menu-item index="2">产品</ola-menu-item>
                <ola-sub-menu index="3">
                    <template #title>服务</template>
                    <ola-menu-item index="3-1">咨询</ola-menu-item>
                    <ola-menu-item index="3-2">定制</ola-menu-item>
                </ola-sub-menu>
                <ola-menu-item index="4">关于我们</ola-menu-item>
            </ola-menu>
        </section>

        <section class="demo-section">
            <h2>标签页组件</h2>
            <ola-tabs v-model="activeTab">
                <ola-tab-pane name="tab1" label="标签页1">标签页1内容</ola-tab-pane>
                <ola-tab-pane name="tab2" label="标签页2">标签页2内容</ola-tab-pane>
                <ola-tab-pane name="tab3" label="标签页3">标签页3内容</ola-tab-pane>
            </ola-tabs>
        </section>

        <section class="demo-section">
            <h2>轮播组件</h2>

            <h3>基础轮播</h3>
            <ola-carousel height="300px" indicator-position="outside" arrow="hover">
                <ola-carousel-item>
                    <div class="carousel-item">优质中外教 学纯正法语</div>
                </ola-carousel-item>
                <ola-carousel-item>
                    <div class="carousel-item">全球师资品质学习 助你轻松圆梦法国</div>
                </ola-carousel-item>
            </ola-carousel>

            <h3>图片轮播 - 单行文字动画（自动滚动）</h3>
            <ola-carousel height="300px" indicator-type="dots" indicator-position="inside" arrow="hover"
                :autoplay="true" :interval="5000">
                <ola-carousel-item type="image"
                    source="https://file.olacio.com/upload/school/3/banner/6/c86f67ec-51ca-466f-9ea2-4b29e399b800/巩固学习.png"
                    alt="山脉风景" :text-lines="1">
                    <h2 class="carousel-title">成为一名真正的跨文化沟通者</h2>
                </ola-carousel-item>

                <ola-carousel-item type="image"
                    source="https://file.olacio.com/upload/school/3/banner/6/853fc820-f719-4dd0-a8fc-ce5ca22326e6/葡语商务banner.png"
                    alt="河流风景" :text-lines="1">
                    <h2 class="carousel-title">探索葡语商务世界</h2>
                </ola-carousel-item>

                <ola-carousel-item type="image"
                    source="https://file.olacio.com/upload/school/6/banner/11/image/57b4a1f4-354d-4b5f-864e-9c5d98c2ce11/法语_PC_BANNER.png"
                    alt="城市风景" :text-lines="1">
                    <h2 class="carousel-title">体验法语之美</h2>
                </ola-carousel-item>
            </ola-carousel>

            <h3>图片轮播 - 多行文字动画（手动滚动）</h3>
            <ola-carousel height="300px" indicator-type="dots" indicator-position="inside" arrow="hover">
                <ola-carousel-item type="image"
                    source="https://file.olacio.com/upload/school/3/banner/6/c86f67ec-51ca-466f-9ea2-4b29e399b800/巩固学习.png"
                    alt="山脉风景" :text-lines="2">
                    <h2 class="carousel-title">成为一名真正的跨文化沟通者</h2>
                    <p class="carousel-subtitle">探索语言与文化的奇妙世界</p>
                </ola-carousel-item>

                <ola-carousel-item type="image"
                    source="https://file.olacio.com/upload/school/3/banner/6/853fc820-f719-4dd0-a8fc-ce5ca22326e6/葡语商务banner.png"
                    alt="河流风景" :text-lines="2">
                    <h2 class="carousel-title">探索葡语商务世界</h2>
                    <p class="carousel-subtitle">掌握专业葡语，开启国际商务之门</p>
                </ola-carousel-item>

                <ola-carousel-item type="image"
                    source="https://file.olacio.com/upload/school/6/banner/11/image/57b4a1f4-354d-4b5f-864e-9c5d98c2ce11/法语_PC_BANNER.png"
                    alt="城市风景" :text-lines="2">
                    <h2 class="carousel-title">体验法语之美</h2>
                    <p class="carousel-subtitle">感受法国文化的优雅与魅力</p>
                </ola-carousel-item>
            </ola-carousel>

            <h3>视频轮播</h3>
            <ola-carousel height="300px" indicator-position="none" arrow="hover">
                <ola-carousel-item type="video" source="http://vjs.zencdn.net/v/oceans.mp4" :video-controls="true"
                    :text-lines="2">
                    <h2 class="carousel-title">精彩视频内容</h2>
                    <p class="carousel-subtitle">观看我们的教学示范</p>
                </ola-carousel-item>

                <ola-carousel-item type="video" source="https://www.w3schools.com/html/movie.mp4" :video-controls="true"
                    :text-lines="1">
                    <h2 class="carousel-title">更多精彩内容</h2>
                </ola-carousel-item>
            </ola-carousel>
        </section>

        <!-- Logo组件示例 -->
        <div class="demo-section">
            <h2>Logo组件</h2>
            <div class="demo-row">
                <ola-logo src="https://olacio.com/img/olacio_edu_logo.jpg" height="50"></ola-logo>
                <ola-logo :useLocaleLogo="true" filename="logo.png" height="40"></ola-logo>
                <ola-logo to="/" :useLocaleLogo="true" height="30"></ola-logo>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ComponentDemo',
    data() {
        return {
            activeTab: 'tab1'
        };
    }
};
</script>

<style lang="scss">
.component-demo {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;

    .demo-section {
        margin-bottom: 40px;
    }

    .demo-section h3 {
        margin: 20px 0 10px;
        font-size: 18px;
        color: #666;
    }

    .demo-row {
        display: flex;
        gap: 10px;
        margin-bottom: 15px;
    }

    .carousel-item {
        height: 100%;
        background-color: #f5f5f5;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
        color: #333;
        font-weight: 500;
    }

    /* 轮播文字样式 */
    .carousel-title {
        font-size: 48px;
        font-weight: 500;
        margin: 0 0 10px;
        color: #fff;
    }

    .carousel-subtitle {
        font-size: 18px;
        margin: 0;
        color: #fff;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    }

    /* 确保轮播组件中的文字正确显示 */
    .ola-carousel-item__text-overlay {
        pointer-events: none;
        /* 允许点击穿透到轮播控件 */
    }

    .ola-carousel-item__text-container {
        padding: 15px 25px;
        border-radius: 8px;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);
    }

    /* 增强文字动画效果 */
    .text-animation-single .ola-carousel-item__text-container {
        transition-duration: 1s !important;
    }

    .text-animation-multiple .ola-carousel-item__text-container>* {
        transition-duration: 1s !important;
    }

    /* 为轮播项添加不同的背景色以区分 */
    .ola-carousel-item:nth-child(1) .carousel-item {
        background-color: #e8f5e9;
    }

    .ola-carousel-item:nth-child(2) .carousel-item {
        background-color: #e3f2fd;
    }

    .ola-carousel-item:nth-child(3) .carousel-item {
        background-color: #fff8e1;
    }
}
</style>